/*
 * @file: main.tsx
 * @description: App Configration
 * @date: 27 Feb 2024
 * @author: Mohit
 * */

import React from 'react';
import { PersistGate } from 'redux-persist/es/integration/react';
import 'react-datepicker/dist/react-datepicker.css';
import { Provider } from 'react-redux';
import { Navigate } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import configureStore from './config';
import Dashboard from './pages/Dashboard';
import Login from './pages/Login';
import Forgotpassword from './pages/Forgotpassword';
import Resetpassword from './pages/Resetpassword';
import Profile from './pages/Profile';
import Settings from './pages/Settings';
import Newsletters from './pages/Newsletter/Newsletters';
import Newslettersdetail from './pages/Newsletter/Newslettersdetail';
import 'react-pagination-js/dist/styles.css';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import 'react-phone-input-2/lib/style.css';
import Transactions from './pages/Transactions';
import './scss/main.scss';
import ContactDetails from './pages/Settings/ContactDetails';
import DashboardPage from './pages/Dashboard/DashboardPage';
import Users from './pages/Users';
import AddEditUser from './pages/Users/AddEditUser';
import UserDetail from './pages/Users/Profiledetail';
import Roles from './pages/Roles';
import AddEditRole from './pages/Roles/AddEdit';
import LogoSetting from './pages/Setting/index';
import Categories from './pages/Categories';
import AddEditCategory from './pages/Categories/AddEdit';
import CategoryDetail from './pages/Categories/Detail';
import Types from './pages/CategoriesType';
import AddEditTypes from './pages/CategoriesType/AddEdit';
import Features from './pages/Features';
import AddEditFeature from './pages/Features/AddEdit';
import Plans from './pages/Plans';
import AddEditPlan from './pages/Plans/AddEdit';
import Currency from './pages/CurrencyPages';
import AddEditCurrency from './pages/CurrencyPages/AddEditCurrency';
import CurrencyDetail from './pages/CurrencyPages/Detail';
import ApplyCurrency from './pages/CurrencyPages/Applycurrencys';
import Customer from './pages/Customers';
import AddEditCustomer from './pages/Customers/AddEdit';
import ViewCustomer from './pages/Customers/Profiledetail';
import ParticipantType from './pages/ParticipantType';
import AddEditParticipantType from './pages/ParticipantType/AddEdit';
import Skills from './pages/Skills';
import AddEditSkills from './pages/Skills/AddEdit';
import Group from './pages/Group';
import AddEditGroup from './pages/Group/AddEdit';
import AddEditCertification from './pages/Certification/AddEdit';
import Content from './pages/Content';
import AddEditContent from './pages/Content/AddEdit';
import SkillsRoles from './pages/SkillsRoles';
import AddEditSkillsRoles from './pages/SkillsRoles/AddEdit';
import Event from './pages/Events';
import AddEditEvent from './pages/Events/AddEdit';
import ViewEvent from './pages/Events/View';
import Member from './pages/Group/view';
import { ToastContainer } from 'react-toastify';
import SubAdmins from './pages/Sub-Admin';
import AddEditSubAdmin from './pages/Sub-Admin/AddEdit';
import SubAdminDetail from './pages/Sub-Admin/ProfileDetails';
import Blogs from './pages/Blogs';
import AddEditBlogs from './pages/Blogs/AddEdit';
import BlogViewPage from './pages/Blogs/Detail';
import Courses from './pages/Courses';
import AddEditCourse from './pages/Courses/AddEdit';
import CourseViewPage from './pages/Courses/Detail';
import Detailfeature from './pages/Features/Detail';
import PlanDetails from './pages/Plans/Detail';
import AddEditQuestion from './pages/QuestionsBank/AddEdit';
import QuestionBank from './pages/QuestionsBank';
import QuestionViewPage from './pages/QuestionsBank/Details';
import CertificateTemplate from './pages/CertificateTemplate';
import AddEditTemplate from './pages/CertificateTemplate/AddEdit/index';
import DetailTemplate from './pages/CertificateTemplate/Details';
import Assessment from './pages/Assessment/Assessment';
import AddEditassessment from './pages/Assessment/AddEditassessment';
import Assessmentdetail from './pages/Assessment/Assessmentdetail';
import Certificate from './pages/Certification/Certification';
import Certificationdetails from './pages/Certification/Certificationdetails';
import TransactionViewPage from './pages/Transactions/Detail';
import certificateRequestlist from './pages/RequestCertificate/certificateRequestlist';
import viewRequest from './pages/RequestCertificate/viewRequest';
import AddEditFaq from './pages/FAQ\'s/AddEditFaq';
import faqListing from './pages/FAQ\'s/faqListing';
import Viewfaq from './pages/FAQ\'s/viewFaq';
import LessonsParents from './pages/LessonsFromParents/LessonsParents';
import AddEditLessonsParents from './pages/LessonsFromParents/AddEditLessonsParents';
import AddEditInsightsCoaches from './pages/Insights From Coaches/AddEditInsightsCoaches';
import Menu from './pages/MenuItems/Menu';
import AddEditMenu from './pages/MenuItems/AddEditMenu';
import Menudetail from './pages/MenuItems/Menudetail';
import ContentViewPage from './pages/Content/Detail';

/************ store configration *********/
const { persistor, store } = configureStore();

export default () => {
  return (
    <>
      <Provider store={store}>
        <PersistGate loading={'loading ...'} persistor={persistor}>
          <Router>
            <Routes>
              <Route exact={true} path="/dashboard" Component={Dashboard} />
              <Route
                exact={true}
                path="/dashboardpage"
                Component={DashboardPage}
              />
              <Route exact={true} path="/setting" Component={LogoSetting} />
              <Route
                exact={true}
                path="/settings/appointment/contact-details"
                Component={ContactDetails}
              />
              <Route exact={true} path="/users" Component={Users} />
              <Route exact={true} path="/sub-admin" Component={SubAdmins} />
              <Route
                exact={true}
                path="/sub-admin/add"
                Component={AddEditSubAdmin}
              />
              <Route
                exact={true}
                path="/sub-admin/view/:id"
                Component={SubAdminDetail}
              />
              <Route
                exact={true}
                path="/sub-admin/edit/:id"
                Component={AddEditSubAdmin}
              />
              <Route exact={true} path="/roles" Component={Roles} />
              <Route exact={true} path="/roles/add" Component={AddEditRole} />
              <Route
                exact={true}
                path="/roles/edit/:id"
                Component={AddEditRole}
              />
              <Route exact={true} path="/users/add" Component={AddEditUser} />
              <Route exact={true} path="/users/:role" Component={Users} />
              <Route
                exact={true}
                path="/users/edit/:id"
                Component={AddEditUser}
              />
              <Route
                exact={true}
                path="/users/:role/add"
                Component={AddEditUser}
              />
              <Route
                exact={true}
                path="/users/:role/edit/:id"
                Component={AddEditUser}
              />
              <Route
                exact={true}
                path="/userDetail/:id"
                Component={UserDetail}
              />
              <Route exact={true} path="/profile" Component={Profile} />
              <Route exact={true} path="/profile/:tab" Component={Settings} />
              <Route exact={true} path="/login" Component={Login} />
              <Route
                exact={true}
                path="/forgotpassword"
                Component={Forgotpassword}
              />
              <Route
                exact={true}
                path="/resetpassword"
                Component={Resetpassword}
              />

              <Route exact={true} path="/categories" Component={Categories} />
              <Route
                exact={true}
                path="/categories/add"
                Component={AddEditCategory}
              />
              <Route
                exact={true}
                path="/categories/edit/:id"
                Component={AddEditCategory}
              />
              <Route
                exact={true}
                path="/category/:type"
                Component={Categories}
              />
              <Route
                exact={true}
                path="/category/:type/add"
                Component={AddEditCategory}
              />
              <Route
                exact={true}
                path="/category/:type/edit/:id"
                Component={AddEditCategory}
              />
              <Route
                exact={true}
                path="/categoryDetail/:id"
                Component={CategoryDetail}
              />
              {/* Blogs Sections */}

              <Route exact={true} path="/products" Component={Blogs} />
              <Route exact={true} path="/products/add" Component={AddEditBlogs} />
              <Route
                exact={true}
                path="/products/edit/:id"
                Component={AddEditBlogs}
              />
              <Route
                exact={true}
                path="/products/view/:id"
                Component={BlogViewPage}
              />
              {/* Course Sections */}

              <Route exact={true} path="/courses" Component={Courses} />
              <Route
                exact={true}
                path="/course/add"
                Component={AddEditCourse}
              />
              <Route
                exact={true}
                path="/course/edit/:id"
                Component={AddEditCourse}
              />
              <Route
                exact={true}
                path="/course/view/:id"
                Component={CourseViewPage}
              />

              {/* Transaction Type */}

              <Route exact={true} path="/transactions" Component={Transactions} />

              <Route
                exact={true}
                path="/transactions/view/:id"
                Component={TransactionViewPage}
              />

              {/* Categories Type */}
              <Route exact={true} path="/types" Component={Types} />
              <Route exact={true} path="/types/add" Component={AddEditTypes} />
              <Route
                exact={true}
                path="/types/edit/:id"
                Component={AddEditTypes}
              />
              {/* Feature */}
              <Route exact={true} path="/features" Component={Features} />
              <Route
                exact={true}
                path="/features/add"
                Component={AddEditFeature}
              />
              <Route
                exact={true}
                path="/features/edit/:id"
                Component={AddEditFeature}
              />
              <Route
                exact={true}
                path="/features/:id"
                Component={Detailfeature}
              />
              {/* Plans */}
              <Route exact={true} path="/plans" Component={Plans} />
              <Route exact={true} path="/plans/add" Component={AddEditPlan} />
              <Route
                exact={true}
                path="/plans/edit/:id"
                Component={AddEditPlan}
              />
              <Route
                exact={true}
                path="/plan/view/:id"
                Component={PlanDetails}
              />
              <Route
                exact={true}
                path="/certificate-requests"
                Component={certificateRequestlist}
              />
              <Route
                exact={true}
                path="/request/:assessmentId"
                Component={viewRequest}
              />
              {/* {FAQ} */}
              <Route exact={true} path="/faq" Component={faqListing} />
              <Route exact={true} path="/faq/add" Component={AddEditFaq} />
              <Route exact={true} path="/faq/edit/:id" Component={AddEditFaq} />
              <Route exact={true} path="/faq/view/:id" Component={Viewfaq} />

              {/* {Questions} */}
              <Route exact={true} path="/questions" Component={QuestionBank} />
              <Route
                exact={true}
                path="/question/add"
                Component={AddEditQuestion}
              />
              <Route
                exact={true}
                path="/question/edit/:id"
                Component={AddEditQuestion}
              />
              <Route
                exact={true}
                path="/question/view/:id"
                Component={QuestionViewPage}
              />

              <Route
                exact={true}
                path="/certificate-templates"
                Component={CertificateTemplate}
              />
              <Route
                exact={true}
                path="/template/add"
                Component={AddEditTemplate}
              />
              <Route
                exact={true}
                path="/template/edit/:id"
                Component={AddEditTemplate}
              />
              <Route
                exact={true}
                path="/template/view/:id"
                Component={DetailTemplate}
              />
              {/* Participent Type */}
              <Route
                exact={true}
                path="/participant-type"
                Component={ParticipantType}
              />
              <Route
                exact={true}
                path="/participant-type/add"
                Component={AddEditParticipantType}
              />
              <Route
                exact={true}
                path="/participant-type/edit/:id"
                Component={AddEditParticipantType}
              />
              {/* Skills */}
              <Route exact={true} path="/skills" Component={Skills} />
              <Route
                exact={true}
                path="/skills/add"
                Component={AddEditSkills}
              />
              <Route
                exact={true}
                path="/skills/edit/:id"
                Component={AddEditSkills}
              />
              {/* Skills Roles*/}
              <Route exact={true} path="/skill-roles" Component={SkillsRoles} />
              <Route
                exact={true}
                path="/skill-roles/add"
                Component={AddEditSkillsRoles}
              />
              <Route
                exact={true}
                path="/skill-roles/edit/:id"
                Component={AddEditSkillsRoles}
              />
              {/* Group */}
              <Route exact={true} path="/group" Component={Group} />
              <Route exact={true} path="/group/add" Component={AddEditGroup} />
              <Route
                exact={true}
                path="/group/edit/:id"
                Component={AddEditGroup}
              />
              <Route exact={true} path="/member/:id" Component={Member} />
              {/* Certification */}
              <Route
                exact={true}
                path="/certificate"
                Component={Certificate}
              />
              <Route
                exact={true}
                path="/certification/add"
                Component={AddEditCertification}
              />
              <Route
                exact={true}
                path="/certification/edit/:id"
                Component={AddEditCertification}
              />

              <Route
                exact={true}
                path="/certification/view/:id"
                Component={Certificationdetails}
              />
              {/* Events */}
              <Route exact={true} path="/event" Component={Event} />
              <Route exact={true} path="/event/add" Component={AddEditEvent} />
              <Route
                exact={true}
                path="/event/edit/:id"
                Component={AddEditEvent}
              />
              <Route
                exact={true}
                path="/event/detail/:id"
                Component={ViewEvent}
              />
              {/* Content */}
              <Route exact={true} path="/content" Component={Content} />
              {/* <Route
                exact={true}
                path="/content/add"
                Component={AddEditContent}
              /> */}
              <Route
                exact={true}
                path="/content/edit/:id?"
                Component={AddEditContent}
              />
              <Route
                exact={true}
                path="/content/view/:id?"
                Component={ContentViewPage}
              />
              {/* Currency */}
              <Route exact={true} path="/currency" Component={Currency} />
              <Route
                exact={true}
                path="/currency/add"
                Component={AddEditCurrency}
              />
              <Route
                exact={true}
                path="/currency/edit/:id"
                Component={AddEditCurrency}
              />
              <Route
                exact={true}
                path="/currency/:id"
                Component={CurrencyDetail}
              />
              {/* Apply Currency */}
              <Route
                exact={true}
                path="/applycurrency"
                Component={ApplyCurrency}
              />
              <Route exact={true} path="/customer" Component={Customer} />
              <Route
                exact={true}
                path="/customer/add"
                Component={AddEditCustomer}
              />
              <Route
                exact={true}
                path="/customer/edit/:id"
                Component={AddEditCustomer}
              />
              <Route
                exact={true}
                path="/customer/view/:id"
                Component={ViewCustomer}
              />
              {/* Assessment */}
              <Route
                exact={true}
                path="/assessment"
                Component={Assessment}
              />
              <Route
                exact={true}
                path="/assessment/add"
                Component={AddEditassessment}
              />
              <Route
                exact={true}
                path="/assessment/edit/:id"
                Component={AddEditassessment}
              />

              <Route
                exact={true}
                path="/assessment/view/:id"
                Component={Assessmentdetail}
              />

              <Route
                exact={true}
                path="/newsletters"
                Component={Newsletters}
              />

              <Route
                exact={true}
                path="/newsletter/view/:id"
                Component={Newslettersdetail}
              />
              {/* Dynamic pages */}
              {/* <Route
                exact={true}
                path="/lessons/parents"
                Component={LessonsParents}
              /> */}
              <Route
                exact={true}
                path="/lessons/parents"
                Component={AddEditLessonsParents}
              />
              <Route
                exact={true}
                path="/insights/coaches"
                Component={AddEditInsightsCoaches}
              />
              {/* Menu */}
              <Route
                exact={true}
                path="/menu"
                Component={Menu}
              />
              <Route
                exact={true}
                path="/menu/add"
                Component={AddEditMenu}
              />
              <Route
                exact={true}
                path="/menu/edit/:id"
                Component={AddEditMenu}
              />
              <Route
                exact={true}
                path="/menu/view/:id"
                Component={Menudetail}
              />
              <Route exact path="/" element={<Navigate to="/login" />} />
            </Routes>
          </Router>
        </PersistGate>
      </Provider>
      <div id="loader" className="loaderDiv d-none">
        <div>
          <img src="/assets/img/loader.gif" alt="logo" className="loaderlogo" />
        </div>
      </div>
      <ToastContainer position="top-right" />
    </>
  );
};
